G.TreasureHunt.TreasureHuntTutorial = function() {
  Phaser.Group.call(this, game);
  this.fixedToCamera = true;

  this.overlay = game.add.graphics(0, 0, this);
  this.overlay.inputEnabled = true;

  this.bg = G.makeImage(0, 0, "th_tutorial_box", 0.5, this);
  this.bg.scale.x = 1.1;

  this.closeBtn = this.add(new G.Button(240, -230, "btn_x", function() {
    this.destroy();
  }, this));

  this.howToCollectTxt = this.add(new G.Text(0, -170, OMT.language.getText("How to collect Gems?"), {
    style: "font-purple",
    fontSize: 35,
  }, 0.5, 500, 100));

  this.descTxt = this.add(new G.Text(0, -90,
    OMT.language.getText("Match next to purple chests to collect what’s inside!"), {
    style: "font-purple",
    fontSize: 30,
    lineSpacing: -10,
  }, 0.5, 400, 140, true, "center"));

  this.tutorialImg = G.makeImage(-20, 90, "tutorial_image", 0.5, this);

  G.Utils.cleanUpOnDestroy(this, 
    G.sb("onScreenResize").add(this.onResize, this));
  this.onResize();
};

G.TreasureHunt.TreasureHuntTutorial.prototype = Object.create(Phaser.Group.prototype);

G.TreasureHunt.TreasureHuntTutorial.prototype.onResize = function() {
  this.cameraOffset.setTo(
    Math.floor(game.width*0.5),
    Math.floor(game.height*0.5)
  );

  this.overlay.beginFill(0x000000, 0.5);
  this.overlay.drawRect(
    -game.width*0.5,
    -game.height*0.5,
    game.width,
    game.height
  );
};